import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';
import { useLocation, useOutlet } from 'react-router';
import { getLenis, LenisProvider } from '@/providers/LenisProvider';
import { CursorTracker } from './CursorTracker';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { ScrollProgress } from './ScrollProgress';
import { WhatsAppButton } from './WhatsAppButton';

export function RootLayout() {
  const location = useLocation();
  const outlet = useOutlet();

  // On navigation: scroll to the hash section if present, else reset to top.
  // (Handles header anchor links like /#creazioni, also from other pages.)
  useEffect(() => {
    const lenis = getLenis();
    if (location.hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          if (lenis) lenis.scrollTo(el as HTMLElement, { offset: -80 });
          else (el as HTMLElement).scrollIntoView({ behavior: 'smooth' });
        }
      }, 120);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash, location.key]);

  return (
    <LenisProvider>
      <div className="grain min-h-screen">
        <ScrollProgress />
        <CursorTracker />
        <Navbar />
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            {outlet}
          </motion.main>
        </AnimatePresence>
        <Footer />
        <WhatsAppButton />
      </div>
    </LenisProvider>
  );
}
